'use client';

import clsx from 'clsx';
import type { CSSProperties } from 'react';
import styles from './FormGroup.module.scss';

export type FieldSize = 'lg' | 'md' | 'sm';

export interface FormGroupProps {
  className?: string;
  style?: CSSProperties;
  children: React.ReactNode;
  columns?: number;
}

export default function FormGroup({ className, style, children, columns }: FormGroupProps) {
  const mergedStyle = columns
    ? { '--form-group-columns': columns, ...style } as CSSProperties
    : style;
  return (
    <div className={clsx(styles.root, className)} style={mergedStyle}>
      {children}
    </div>
  );
}
